import { z } from "zod";

export const addressSchema = z.object({
  companyName: z.string().optional().default(""),
  first_name: z.string().min(1, "Le prénom est requis"),
  last_name: z.string().min(1, "Le nom est requis"),
  address1: z.string().min(1, "L'adresse est requise").max(230),
  address2: z.string().max(230).optional().default(""),
  city: z.string().min(1, "La ville est requise"),
  zip: z
    .string()
    .min(1, "Le code postal est requis")
    .transform((v) => v.trim()),
  country_code: z.string().min(2, "Le pays est requis"),
  email: z.string().email("E-mail invalide"),
  phone: z.string().min(1, "Le numéro de téléphone est requis"),
});

export type AddressFormValues = z.infer<typeof addressSchema>;
